import React, { FC } from 'react';
import { ShortLinkView } from '../components';

export const LinkTrackingPage: FC = () => {
  return <ShortLinkView />;
};
